import { ETypeDate } from "./types";

export type IndexDay = 0 | 1;// 0 for Sunday, 1 for Monday

/**
 * @param type 
 * @param StartDay 
 * @returns
 */
export function GetDateRange(type: ETypeDate): { dateType: ETypeDate, startDate: Date; endDate: Date } {
    const today = new Date();

    switch (type) {
        case ETypeDate.Now:
            return { dateType: type, startDate: today, endDate: today };
        case ETypeDate.Yesterday: {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            return { dateType: type, startDate: yesterday, endDate: yesterday };
        }
        case ETypeDate.Tomorrow: {
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            return { dateType: type, startDate: tomorrow, endDate: tomorrow };
        }
        case ETypeDate.LastWeek: {
            const lastWeekStart = new Date(today);
            lastWeekStart.setDate(today.getDate() - today.getDay() + 1);
            const lastWeekEnd = new Date(lastWeekStart);

            lastWeekEnd.setDate(lastWeekStart.getDate() + 6);
            return { dateType: type, startDate: lastWeekStart, endDate: lastWeekEnd };
        }
        case ETypeDate.ThisWeek: {
            const thisWeekStart = new Date(today);
            thisWeekStart.setDate(today.getDate() - today.getDay() + (today.getDay() == 0 ? -6 : 1));

            const thisWeekEnd = new Date(thisWeekStart);
            thisWeekEnd.setDate(thisWeekStart.getDate() + 6);
            if (thisWeekEnd > today) {
                thisWeekEnd.setDate(today.getDate());
            }
            return { dateType: type, startDate: thisWeekStart, endDate: thisWeekEnd };
        }
        case ETypeDate.LastMonth: {
            const lastMonthStart = new Date(today);
            lastMonthStart.setMonth(today.getMonth() - 1, 1);
            const lastMonthEnd = new Date(lastMonthStart);
            lastMonthEnd.setMonth(lastMonthStart.getMonth() + 1, 0);
            return { dateType: type, startDate: lastMonthStart, endDate: lastMonthEnd };
        }
        case ETypeDate.BeforeLastYear: {
            const beforeLastYearStart = new Date(today);
            beforeLastYearStart.setFullYear(today.getFullYear() - 2, 0, 1); // Two years before
            const beforeLastYearEnd = new Date(beforeLastYearStart);
            beforeLastYearEnd.setFullYear(beforeLastYearStart.getFullYear(), 11, 31); // December 31st of that year
            return { dateType: type, startDate: beforeLastYearStart, endDate: beforeLastYearEnd };
        }
        case ETypeDate.LastYear: {
            const lastYearStart = new Date(today);
            lastYearStart.setFullYear(today.getFullYear() - 1, 0, 1);
            const lastYearEnd = new Date(lastYearStart);
            lastYearEnd.setFullYear(lastYearStart.getFullYear(), 11, 31);
            return { dateType: type, startDate: lastYearStart, endDate: lastYearEnd };
        }
        case ETypeDate.MonthToDate: {
            const monthToDateStart = new Date(today);
            monthToDateStart.setDate(1);
            return { dateType: type, startDate: monthToDateStart, endDate: today };
        }
        case ETypeDate.YearToDate: {
            const yearToDateStart = new Date(today);
            yearToDateStart.setMonth(0, 1);
            return { dateType: type, startDate: yearToDateStart, endDate: today };
        }
        default:
            throw new Error(`Invalid date type: ${type}`);
    }
}

/**
 * Counts the number of months between two dates.
 * @param startDate 
 * @param endDate 
 * @returns 
 */
export function CountMonths(startDate: Date, endDate: Date): number {
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        throw new Error("Invalid date objects provided.");
    }

    if (endDate < startDate) {
        throw new Error("The end date must be after the start date.");
    }

    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth();
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth();

    let monthCount = (endYear - startYear) * 12 + (endMonth - startMonth);

    // Adjust for full-month inclusion if start is first day and end is last day
    const isStartFirstDay = startDate.getDate() === 1;
    const isEndLastDay = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).getDate() === endDate.getDate();

    if (isStartFirstDay && isEndLastDay) {
        monthCount += 1;
    }

    return monthCount;
}
